<template>
	<article :class="[props.classes, { divider: props.showDivider }]" class="article-list-item">
		<BaseLink
			:link="{ router: 'blog-post', params: { blogPostUrlSlug: props.article.slug.current } }"
			:classes="props.baseLinkClasses"
		>
			<slot>
				<ArticleCoverImage
					v-if="props.article?.coverImage && props.article.coverImage.asset && props.showCoverImage"
					:cover-image="props.article.coverImage.asset"
				/>
				<p
					v-if="props.showDate"
					:class="[
						'mt-50',
						{
							'display-flex align-items-center': props.article.showNewBadge
						}
					]"
				>
					<ArticleDate :date-string="props.article.date" class="overline" />
					<Badge
						v-if="props.article.showNewBadge"
						class="ml-50"
						background="slate"
						text="New"
						size="medium"
					/>
				</p>
				<h3 class="article-title heading-6 mt-50">{{ props.article.title }}</h3>
				<p v-if="props.article.abstract" class="mt-50" v-html="props.article.abstract"></p>
			</slot>
		</BaseLink>
	</article>
</template>

<script setup lang="ts">
import ArticleCoverImage from '@components/blog/article-cover-image.vue';
import ArticleDate from '@components/blog/article-date.vue';
import Badge from '@components/badges/badge-component.vue';
import { SanityArticleTeaser } from 'types/sanity/blog-education-center';

interface Props {
	article: SanityArticleTeaser;
	classes?: string;
	baseLinkClasses?: string;
	showCoverImage?: boolean;
	showDate?: boolean;
	showDivider?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	showCoverImage: false,
	showDate: false,
	showDivider: false,
	baseLinkClasses: '',
	classes: ''
});
</script>
